<mojo-page-title [title]="title$ | async" ref=""></mojo-page-title>
